import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function ServiceDeadlines() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
      <React.Fragment>
    <Meta
        title="Гарантийные сроки устранения неисправностей интернета и связи | «ИТ Особа»"
        description="Прозрачные SLA для клиентов. Узнайте, в какие сроки мы гарантированно устраняем проблемы со связью, интернетом и оборудованием. Приоритетная поддержка для бизнеса."
      />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          fontSize: '2.5em',
          color: '#34495e',
        }}
      >
        Временные рамки для устранения неполадок в предоставлении связи от "ИТ Особа"
      </h1>

      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Наш договор обслуживания предполагает своевременное реагирование и устранение неисправностей — это помогает существенно снизить затраты по сравнению с постоянным содержанием технического персонала внутри компании. Мы стремимся быстро и качественно решать любые технические ситуации, поскольку рыночная конкуренция очень высока, и она подталкивает нас к эффективности.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>О компании</h2>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        «ИТ Особа» — команда профессионалов, для которых информационные технологии — не просто работа, а страсть. Мы ставим задачу превзойти ожидания клиентов через стабильность работы, чёткое выполнение процессов и индивидуальный подход, учитывающий особенности каждого клиента.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Преимущества сотрудничества</h2>

      <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
        <li style={{ fontSize: '1.2em', marginBottom: '10px' }}>Быстрая диагностика и устранение любых сложностей с оборудованием и соединениями.</li>
        <li style={{ fontSize: '1.2em', marginBottom: '10px' }}>Полная ответственность за оказанные услуги, детали, а также гарантийные обязательства.</li>
        <li style={{ fontSize: '1.2em', marginBottom: '10px' }}>Мгновенная реакция и круглосуточная поддержка без выходных и праздников.</li>
        <li style={{ fontSize: '1.2em', marginBottom: '10px' }}>Назначенный специалист или команда специалистов для оперативного решения задач.</li>
      </ul>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Рамки реагирования на неисправности</h2>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Время, в течение которого мы обязуемся реагировать и устранять сбои после получения заявки, зависит от типа клиента и характера проблемы:
      </p>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ fontSize: '1.2em', marginBottom: '10px' }}><strong>Для юридических лиц:</strong> от 3 часов до 24 часов</li>
        <li style={{ fontSize: '1.2em', marginBottom: '10px' }}><strong>Для индивидуальных клиентов:</strong> от 3 часов до 72 часов</li>
      </ul>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        <strong>Обратите внимание:</strong> Ненадлежащее обслуживание со стороны клиента или отсутствие доступа к месту проведения работ могут повлиять на заявленные сроки.
      </p>
      <h3 style={{ marginTop: '30px', color: '#34495e' }}>Особые случаи</h3>
      <ul style={{ paddingLeft: '20px' }}>
        <li  style={{ fontSize: '1.2em', marginBottom: '10px' }}><strong>При сбоях на основных магистралях связи:</strong> от 3 до 8 часов</li>
        <li  style={{ fontSize: '1.2em', marginBottom: '10px' }}><strong>При аварийных ситуациях на точках доступа:</strong> от 3 до 24 часов</li>
        <li  style={{ fontSize: '1.2em', marginBottom: '10px' }}><strong>При повреждении магистральных оптоволоконных линий:</strong> от 3 до 24 часов</li>
        <li  style={{ fontSize: '1.2em', marginBottom: '10px' }}><strong>При повреждении межузловых или медных кабелей:</strong> от 8 до 72 часов</li>
      </ul>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        <strong>Важно:</strong> Эти сроки действуют при условии наличия доступа к месту неисправности. В случае отсутствия доступа, выполнение работ может быть задержано по обстоятельствам, не зависящим от нашей компании.
      </p>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button>
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть окно"
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={e => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}